import { HStack, Text } from '@chakra-ui/react';
import { formatTimeDistance } from '@util/helpers';
import { omit } from 'lodash-es';

function getRulesCount(matchRules) {
  if (!matchRules) {
    return 0;
  }

  const rules = omit(matchRules, ['schedule']);
  const rulesArrays = Object.values(rules);

  return rulesArrays.reduce((acc, curr) => acc + curr.length, 0);
}

export default function FocusMetadata({ focus }) {
  const followersCount = focus?.collaborators?.length ?? 0;
  const rulesCount = getRulesCount(focus?.match_rules);
  const color = focus?.archived_at ? 'surface.outline' : 'surface.onSurface';

  return (
    <HStack
      gap={3}
      alignItems='center'
      fontSize='sm'
      fontWeight={500}
    >
      <Text color={color}>{followersCount} followers</Text>
      <Text color={color}>{rulesCount} rules</Text>
      <Text
        color={color}
        fontWeight={400}
      >
        Updated {formatTimeDistance(focus?.updated_at, true)}
      </Text>
    </HStack>
  );
}
